/* unplugin-vue-components disabled */import script from "./group-chat.vue?vue&type=script&lang=ts&setup=true"
export * from "./group-chat.vue?vue&type=script&lang=ts&setup=true"

import "./group-chat.vue?vue&type=style&index=0&id=3aa610a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa610a7"]])

export default __exports__